import {Component, OnInit} from '@angular/core';
import {TransferidAchteurService} from '../transferid-achteur.service';
import {AcheteurService} from '../../../../modules/services/acheteur/acheteur.service';
import {VAchteur} from '../../../../domain/acheteur/acheteur';
import {TranslateService} from '@ngx-translate/core';
import {AppTranslateService} from '../../../../modules/services/translate/app-translate.service';

@Component({
    selector: 'app-recap-inscrption-acheteur',
    templateUrl: './recap-inscrption-acheteur.component.html',
    styleUrls: ['./recap-inscrption-acheteur.component.css'],
})
export class RecapInscrptionAcheteurComponent implements OnInit {
    data: VAchteur[] = [];

    langue: any;

    constructor(
        private transfer: TransferidAchteurService,
        private translate: TranslateService,
        private appTranslateService: AppTranslateService,
        private achteurService: AcheteurService
    ) {
        /*    this.translate.onLangChange.subscribe((x) => {
          this.langue = x.langue;
        });*/
    }

    ngOnInit(): void {
        this.getdetail();
        this.langue = this.getlang();
    }

    getdetail() {
        this.achteurService.getDetailVachteur(this.transfer.getData()).subscribe({
            next: (data) => {
                this.data = [data];
            },
        });
    }


    getlang() {
        this.appTranslateService.getDefaultLang();
    }


}
